import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkSuperSub from 'remark-supersub';
import { IChatMessage } from '../../../../../libs/models/ChatMessage';
import * as utils from './../../../../utils/TextUtils';
import renderers from './renderers/CustomRenderers';

interface ChatItemTextContentProps {
    message: IChatMessage;
}

export const ChatItemTextContent: React.FC<ChatItemTextContentProps> = ({ message }) => {
    const content = utils.replaceCitationLinksWithIndices(utils.formatChatTextContent(message), message);

    return (
        <div className="flex w-full flex-col lg:justify-between [&_sup]:text-slate-900 [&_sup]:rounded-sm [&_sup]:bg-slate-200 [&_sup]:pt-[1px] [&_sup]:pr-[3px] [&_sup]:pb-[1px] [&_sup]:pl-[2px] [&_sup]:mr-[2px]">
            <ReactMarkdown remarkPlugins={[remarkGfm, remarkSuperSub]} components={renderers}>
                {content}
            </ReactMarkdown>
        </div>
    );
};
